import React, { Fragment, useState } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate } from "react-router";
import FBannerSpendResponsive from "../../components/FBannerSpendResponsive/FBannerSpend";
import FcardPaymentMethod from "../../components/FcardPaymentMethod/FcardPaymentMethod";

const BankCheckScreen = ({ param }) => {
  const route = useNavigate();

  const arrayGroups = [
    {
      name: "",
      members: "Pago con cheque",
      onclick: () => {
        route("/ManageGroupScreen");
      },
    },
    {
      name: "",
      members: "Pago con Zelle",
      onclick: () => {
        route("/ManageGroupScreen");
      },
    },
    {
      name: "",
      members: "Pago con QR",
      onclick: () => {
        route("/ManageGroupScreen");
      },
    },
  ];
  return (
    <>
      <FBannerSpendResponsive
        title="¿Qué forma de pago prefieres?"
        subTitle="$200 USD"
        // subTitle="Saldo Disponible"
        img={require("../../components/assets/images/pedir-icon.png")}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="py-4 border-0 border-dashed p-3 max-h-screen mb-16">
          <FcardPaymentMethod arrayGroups={arrayGroups} />
          <br />
        </div>
      </div>
    </>
  );
};

export default BankCheckScreen;
